import ProviderInvoiceCategoryFormConfig from "./form";
import GenericForm from "../GenericForm";
import { ProviderInvoiceCategoryFormData } from "@/formTypes/ProviderInvoiceCategoryDataType";
import { ProviderInvoiceCategoryApi, ProviderInvoiceCategoryDataType } from "@/api/ProviderInvoiceCategoryApi";

type ProviderInvoiceCategoryFormProps = {
  id?: string;
  formId: string,
  saveRedirectUrl: string
}

const ProviderInvoiceCategoryForm = (props: ProviderInvoiceCategoryFormProps) => {

  return (
    <GenericForm<ProviderInvoiceCategoryFormData, ProviderInvoiceCategoryDataType>
      id={props.id}
      formId={props.formId}
      saveRedirectUrl={props.saveRedirectUrl}
      formConfig={ProviderInvoiceCategoryFormConfig}
      getById={(...arg) => ProviderInvoiceCategoryApi.get(...arg)}
      createFn={(...arg) => ProviderInvoiceCategoryApi.create(...arg)}
      updateFn={(...arg) => ProviderInvoiceCategoryApi.update(...arg)}
      successMessage="La Categoria de Compras ha sido almacenada correctamente"
      errorMessage="No fue posible almacenar la información de la Categoria de Compras"
    />
  )
}

export default ProviderInvoiceCategoryForm;